module.exports = __webpack_public_path__ + "static/2-d5db88df56ef56a1281c7616d68d3678.png";